// src/components/UserLocationMarker.js
import React from 'react';
import { Marker } from '@react-google-maps/api';
import IconUserLocationMarker from '../assets/icons/icon-user-location-marker.svg';

export default function UserLocationMarker({ position }) {
    return (
        <Marker
            position={position}
            icon={{
                url: IconUserLocationMarker,
                scaledSize: new window.google.maps.Size(40, 40),
                anchor: new window.google.maps.Point(20, 20),
            }}
        />
    );
}
